var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "tw-flex tw-flex-col tw-justify-center tw-items-center tw-bg-gray-300 tw-h-screen tw-p-3 login-container"
    },
    [
      _c(
        "div",
        {
          staticClass:
            "tw-flex tw-flex-col tw-shadow tw-relative tw-bg-white tw-rounded tw-p-12 tw-w-full tw-max-w-md tw-md:tw-max-w-2xl"
        },
        [
          _c(
            "div",
            {
              staticClass:
                "tw-w-full tw-flex tw-justify-center tw-items-center tw-pb-8 logo-container"
            },
            [
              _c("img", {
                staticClass: "logo",
                attrs: { src: _vm.footyLogo, alt: "Footy Logo" }
              })
            ]
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "label",
                    {
                      staticClass:
                        "block tw-text-sm tw-text-footy-red tw-pl-1 tw-mb-2",
                      attrs: { for: "user-email" }
                    },
                    [_vm._v("Email")]
                  ),
                  _c("v-text-field", {
                    staticClass: "tw-mt-2",
                    attrs: {
                      id: "user-email",
                      type: "test",
                      placeholder: "Email",
                      outlined: "",
                      "background-color": "white",
                      dense: ""
                    },
                    model: {
                      value: _vm.email,
                      callback: function($$v) {
                        _vm.email = $$v
                      },
                      expression: "email"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "label",
                    {
                      staticClass:
                        "block tw-text-sm tw-text-footy-red tw-pl-1 tw-mb-2",
                      attrs: { for: "user-password" }
                    },
                    [_vm._v("Password")]
                  ),
                  _c("v-text-field", {
                    staticClass: "tw-mt-2",
                    attrs: {
                      id: "user-password",
                      type: "password",
                      placeholder: "Password",
                      outlined: "",
                      "background-color": "white",
                      dense: ""
                    },
                    model: {
                      value: _vm.password,
                      callback: function($$v) {
                        _vm.password = $$v
                      },
                      expression: "password"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-row",
            { staticClass: "error-message-row" },
            [
              _c("v-col", [
                _c("div", { staticClass: "tw-flex tw-justify-center" }, [
                  _vm.error
                    ? _c(
                        "span",
                        { staticClass: "tw-text-center tw-text-footy-red" },
                        [_vm._v(_vm._s(_vm.error))]
                      )
                    : _vm._e()
                ])
              ])
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _c(
                  "button",
                  {
                    staticClass:
                      " tw-w-full tw-bg-blue-500 hover:tw-bg-blue-700 tw-text-white tw-py-2 tw-px-4 tw-font-semibold tw-rounded",
                    on: { click: _vm.login }
                  },
                  [_vm._v(" LOGIN ")]
                )
              ])
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }